<template>
    <div class="sick-box" v-if="canShow('面象分析') && info && info.face_text">
        <div class="risk">面象分析</div>
         <div class="assessment">
            <div class="table-mark">
                <table class="newre-table">
                    <thead>
                        <tr>
                            <th>面象指标</th>
                            <th>面象结果</th>
                        </tr>  
                    </thead>
                    <tbody>
                        <tr>
                            <td>脸颊</td>
                            <td>{{ info.face_text['lian_jia'] ? info.face_text['lian_jia'] : '正常' }}</td>
                        </tr>
                        <tr>
                            <td>眼睑</td>
                            <td>{{ info.face_text['yan_jian'] ? info.face_text['yan_jian'] : '正常' }}</td>
                        </tr>
                        <tr>
                            <td>唇色</td>
                            <td>{{ info.face_text['chun_se'] ? info.face_text['chun_se'] : '正常' }}</td>
                        </tr>
                    </tbody>  
                </table>
            </div>
        </div>
        <div v-if="info.face_text.jiangjie && hasJiangjieAbnormal">
            <div class="face-analysis-title">面象解析</div>
            <div class="dotted-line"></div>
            <div v-if="info.face_text.jiangjie['脸颊'].ID!==0">
                <div class="face-analysis-item" >
                    <div class="face-imgs img-width">
                        <img :src="info.face_text.images.mid_face_with_nose" alt="" @click="previewImage" />
                    </div>
                    <div class="face-title">【脸颊：{{ info.face_text.jiangjie['脸颊'].Jieguo }}】</div>
                    <div class="face-desc">{{ info.face_text.jiangjie['脸颊'].Jiangjie }}</div>
                    <div v-if="info.face_text.jiangjie['脸颊'].Jiangkang">
                        <div class="face-subtitle">【健康指征】</div>
                        <div class="face-desc">{{ info.face_text.jiangjie['脸颊'].Jiangkang }}</div>
                    </div>
                </div>
                <div class="dotted-line"></div>
            </div>
            <div v-if="info.face_text.jiangjie['眼睑'].ID!==0">
                <div class="face-analysis-item" >
                    <div class="face-imgs">
                        <img :src="info.face_text.images.right_eye" alt="" @click="previewImage" />
                        <img :src="info.face_text.images.left_eye" alt="" @click="previewImage" />
                    </div>
                    <div class="face-title">【眼睑：{{ info.face_text.jiangjie['眼睑'].Jieguo }}】</div>
                    <div class="face-desc">{{ info.face_text.jiangjie['眼睑'].Jiangjie }}</div>
                    <div v-if="info.face_text.jiangjie['眼睑'].Jiangkang">
                        <div class="face-subtitle">【健康指征】</div>
                        <div class="face-desc">{{ info.face_text.jiangjie['眼睑'].Jiangkang }}</div>
                    </div>
                </div>
                <div class="dotted-line"></div>
            </div>
            <div v-if="info.face_text.jiangjie['唇色'].ID!==0">
                <div class="face-analysis-item" >
                    <div class="face-imgs">
                        <img :src="info.face_text.images.lips" alt="" @click="previewImage" />
                    </div>
                    <div class="face-title">【唇色：{{ info.face_text.jiangjie['唇色'].Jieguo }}】</div>
                    <div class="face-desc">{{ info.face_text.jiangjie['唇色'].Jiangjie }}</div>
                    <div class="face-subtitle">【健康指征】</div>
                    <div class="face-desc">{{ info.face_text.jiangjie['唇色'].Jiangkang }}</div>
                </div>
                <div class="dotted-line"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { moduleMixin } from '../helpers';
import { ImagePreview } from 'vant';

export default {
    name: 'ReportFace',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info']),
        hasJiangjieAbnormal() {
            const j = this.info && this.info.face_text && this.info.face_text.jiangjie;
            if (!j) return false;
            return ['脸颊', '眼睑', '唇色'].some(
                (key) => j[key] && j[key].ID !== 0
            );
        }
    },
    methods: {
        previewImage(e) {
            const container = e.target.parentNode;
            const imgElements = container.querySelectorAll('img');
            const images = [];
            let startPosition = 0;
            
            imgElements.forEach((img) => {
                const src = img.getAttribute('src');
                if (src) {
                    images.push(src);
                    if (img === e.target) {
                        startPosition = images.length - 1;
                    }
                }
            });

            if (images.length > 0) {
                ImagePreview({
                    images,
                    startPosition
                });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import './Face.scss';
</style>
